<template>
  <div class="file">
    <div class="table-container">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="fileTableRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="displayedList"
        :cell-style="cellStyle"
        @cell-click="cellClick"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        height="200"
      >
        <template v-slot:buttons>
          <template>
            <el-button @click="openUploadHandler" type="primary">上传</el-button>
            <el-button
              @click="deleteBtnClickHandler"
              size="small"
              type="danger"
              class="vxe-btn-delete"
              :disabled="isDisabledDelete"
              style="margin-right: 10px"
              >删除</el-button
            >
            <el-button
              @click="downAllBtnClickHandler"
              size="small"
              type="primary"
              class="vxe-btn-delete"
              style="margin-right: 10px"
              :disabled="isDisabledDelete"
              >批量下载</el-button
            >
          </template>
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
        >
          <template v-slot="{ row }">
            <span v-if="item?.field == 'gmtCreate'">{{
              row[item.field] && formatDateStr(row[item.field])
            }}</span>
            <span v-else-if="item.field === 'operation'">
              <el-button type="text" @click="() => openViewHandler(row)">查看</el-button>
            </span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
    <ViewFile ref="viewFileRef" />
    <!-- 上传弹框组件 -->
    <UploadDialog
      ref="uploadDialogRef"
      @upload="uploadHandler"
      v-bind="$attrs"
      v-on="$listeners"
      :isDisabledUpload="isDisabledUpload || isDisabledUploadBtnByTableData"
      :filePath="filePath"
    />
  </div>
</template>

<script>
  import { formatDate } from '@/utils';
  import API from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  import CONTRACTAPI from '@/api/intermodality/contract';
  import ViewFile from '@/components/business/ViewFile/index.vue';
  import UploadDialog from '@/components/business/UploadDialog/index.vue';
  export default {
    name: 'FileTable',
    props: {
      // 上传文件列表反填到表格中
      attachments: {
        type: Array,
        default: () => [],
      },
      // 是否显示下载按钮
      isShowDownBtn: {
        type: Boolean,
        default: false,
      },
      // 是否禁用删除按钮
      isDisabledDelete: {
        type: Boolean,
        default: false,
      },
      // 是否禁用上传按钮
      isDisabledUpload: {
        type: Boolean,
        default: false,
      },
      // 文件数量,0表示不限制文件数量
      limitFileCount: {
        type: Number,
        default: 0,
      },
      // 是否解析成不同的链接跳转，目前只有多联订单用到
      showLinks: {
        type: Boolean,
        default: false,
      },
      cellStyle: {
        type: Function,
        default: () => {},
      },
      cellClick: {
        type: Function,
        default: () => {},
      },
      defaultPath: {
        type: String,
        default: 'scm/maindata',
      },
      payableSettlementNo: {
        type: String,
        default: () => '',
      },
    },
    computed: {
      displayedList() {
        let originalList = Array.from(this.tableData);
        if (originalList.length != 0) {
          return originalList.filter((item) => {
            return item.isShow == 1 || item.isShow == null;
          });
        }
        return [];
      },
    },
    data() {
      return {
        actionUrl: '',
        filePath: this.defaultPath,
        tableData: [],
        selectionList: [],
        tableColumnList: [
          {
            field: 'attachmentName',
            title: '附件名称',
          },
          {
            field: 'createBy',
            title: '上传人',
          },
          {
            field: 'gmtCreate',
            title: '上传时间',
          },
          { field: 'operation', title: '操作' },
        ],
        isDisabledUploadBtnByTableData: false,
      };
    },
    methods: {
      // 打开上传面板
      openUploadHandler() {
        console.log('打开');
        this.$refs.uploadDialogRef.openDialog();
      },
      openViewHandler(rowItem) {
        this.$refs.viewFileRef.openViewHandler(rowItem);
      },
      disabledUploadBtnHandler() {
        if (this.limitFileCount > 0) {
          this.isDisabledUploadBtnByTableData =
            this.limitFileCount - 1 <= this.$refs.fileTableRef.getTableData().fullData.length;
        } else {
          this.isDisabledUploadBtnByTableData = false;
        }
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },
      formatDateStr(item) {
        return formatDate(item);
      },
      async deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        let approveList = this.selectionList.map((item) => item.isApprove);
        console.log(approveList, approveList.includes(1), 'approveList');
        if (approveList.includes(1)) {
          this.$message.error('含有已审批附件，不可删除');
          return;
        }
        console.log('selectionList', this.selectionList);
        const idsList = this.selectionList.map((item) => item.id);
        let { data } = await this.$axios.post(CONTRACTAPI.DELETE_FILE, {
          ids: idsList,
        });
        console.log('data', data);
        if (data.code == 0) {
          let hidedAttachmentPaths = [];
          this.selectionList.forEach((item) => {
            if (item.dataType == 'PAYABLE_SETTLEMENT_SUPPLY_DETAILS' && item.isShow == '1') {
              hidedAttachmentPaths = item.attachmentPath1;
            }
          });
          if (hidedAttachmentPaths.length != 0) {
            this.tableData = this.tableData.filter(
              (item) => !hidedAttachmentPaths.includes(item.attachmentPath)
            );
          }
          this.tableData = this.tableData.filter((item) => !idsList.includes(item.id));
          this.disabledUploadBtnHandler();
          this.$message.success(data.msg);
          // this.$parent.initDetail();
          // location.reload()
        } else {
          this.$message.error(data.msg);
        }
        // location.reload()
      },
      // 批量下载
      downAllBtnClickHandler() {
        if (this.selectionList.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('upload.noSelectDownLoad'),
            type: 'error',
          });
        } else {
          let params = {
            keyList: this.selectionList.map((it) => it.attachmentKey),
          };
          this.$axios.post(API.DOWNLOAD_FILE, params).then((res) => {
            if (res.data.code == 0) {
              res.data.data.forEach((it) => {
                this.downloadFile(it);
              });
            }
          });
        }
      },
      //多个文件下载
      downloadFile(url) {
        window.open(url, '_blank');
      },
      // 上传成功回调
      async uploadHandler(fileObj) {
        console.log('上传成功回调', fileObj);
        let payableSettlementNo = this.payableSettlementNo;
        let res = await this.$axios.post(CONTRACTAPI.ADD_FILE, {
          ...fileObj,
          dataType: 'PAYABLE_SETTLEMENT',
          dataNo: payableSettlementNo,
        });
        console.log(res, 'res');
        if (res.data.code == 0) {
          this.tableData.push({
            attachmentName: fileObj.attachmentName,
            createBy: fileObj.createBy,
            gmtCreate: XEUtils.toDateString(new Date(), 'yyyy-MM-dd HH:mm:ss'),
            attachmentKey: fileObj.attachmentKey,
            // attachmentId: fileObj.attachmentId,
            attachmentPath: fileObj.attachmentPath,
          });
          this.disabledUploadBtnHandler();
          // this.$parent.initDetail();
        } else {
          this.$message.error(res.data.msg);
        }
        // this.$parent.initDetail();
        // location.reload();
        this.$emit('reloadPage');
      },
      getTableData(isFormatData = true) {
        const $table = this.$refs.fileTableRef;
        if (isFormatData) {
          const tableData = this.tableData;
          return tableData.map((item) => {
            return {
              ...item,
              gmtCreate: item.gmtCreate ? this.formatDateStr(item.gmtCreate) : item.gmtCreate,
            };
          });
        } else {
          return $table.getTableData().fullData;
        }
      },
      // 填充表格数据
      fullTableData(val) {
        console.log('附件表格数据', val);
        this.tableData = val;
      },
    },
    watch: {
      attachments: {
        handler(val) {
          if (val && Array.isArray(val) && val.length) {
            this.fullTableData(val);
            this.disabledUploadBtnHandler();
          }
        },
        immediate: true,
        deep: true,
      },
    },
    components: {
      ViewFile,
      UploadDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .file {
    background: #fff;
    .table-container {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
